<template>
  <div class="pb-4 px-2 text-gray">
    <div class="flex justify-between text-black">
      <div class="pb-4 text-xs">Events <strong>{{displayDate}}</strong></div>
    </div>
    <div class="flex pl-4 border-l-4 border-gray-lighter">
      <div v-for="(b, i) in bangs" class="pr-2 py-2">
        <div class="font-bold font-mono" v-html="parsedSymbol(b.symbol)" />
      </div>
    </div>
  </div>
</template>

<script>
 import {DateTime} from 'luxon';

 export default {
   props: {
     bangs: {
       type: Array,
       required: true
     },

     date: {
       type: String,
       required: true
     }
   },

   computed: {
     displayDate () {
       return DateTime.fromISO(this.date).toFormat('LLL dd, yyyy t')
     },
   },
   methods: {
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     }
   }
 }
</script>
